var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper app"},[_c('router-view'),_c('notifications'),(!_vm.auth && !!_vm.token)?_c('sign_in_component',{staticClass:"sign_in_transparent"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }